import zod from 'zod';

export const stringToList = zod.string()
    .transform((v) =>
        v.length > 0 ? v.split(',') : []
    );

export const stringToListOfNumber = zod.string()
    .transform((v) =>
        v.length > 0 ? v.split(',').map(Number) : []
    );

export function stringToListOfEnum<
    T extends [string, ...string[]]
>(zodEnum: zod.ZodEnum<T>) {
    return zod.string()
        .transform((v) => (v.length > 0 ? v.split(',') : []))
        .pipe(zod.array(zodEnum));
}

export const stringToBoolean = zod.string()
    .transform(v => v === 'true');

export const zodPage = zod.string().transform(v => Number(v) || 1);
export function zodLimit(params?: { defaultValue: number; max: number; }) {
    return zod.string().transform(v => {
        const nv = Number(v) || (params?.defaultValue ?? 25);
        return nv > (params?.max ?? 100) ? (params?.defaultValue ?? 25) : nv;
    });
}
